import styled from 'styled-components'

export const TabsContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.secondary};
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.border.light};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary}40;
    border-radius: 2px;
  }
`

export const TabButton = styled.button<{
  $active: boolean
  $disabled?: boolean
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid
    ${({ theme, $active, $disabled }) =>
      $disabled
        ? theme.colors.border.light
        : $active
          ? theme.colors.primary
          : theme.colors.border.light};
  border-radius: 8px;
  background: ${({ theme, $active, $disabled }) =>
    $disabled
      ? theme.colors.background.secondary
      : $active
        ? theme.colors.primary + '10'
        : theme.colors.background.secondary};
  color: ${({ theme, $active, $disabled }) =>
    $disabled
      ? theme.colors.text.tertiary
      : $active
        ? theme.colors.primary
        : theme.colors.text.primary};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 500 : 400)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ theme, $active, $disabled }) =>
      $disabled
        ? theme.colors.background.secondary
        : $active
          ? theme.colors.primary + '15'
          : theme.colors.background.tertiary};
    border-color: ${({ theme, $disabled }) =>
      $disabled ? theme.colors.border.light : theme.colors.primary};
  }
`

export const TabBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
`
